// Agent Action Types
export const CREATE_AGENT = "CREATE_AGENT";
export const CREATE_AGENT_SUCCESS = "CREATE_AGENT_SUCCESS";
export const CREATE_AGENT_FAILURE = "CREATE_AGENT_FAILURE";

export const UPDATE_AGENT = "UPDATE_AGENT";
export const UPDATE_AGENT_SUCCESS = "UPDATE_AGENT_SUCCESS";
export const UPDATE_AGENT_FAILURE = "UPDATE_AGENT_FAILURE";

export const DELETE_AGENT = "DELETE_AGENT";
export const DELETE_AGENT_SUCCESS = "DELETE_AGENT_SUCCESS";
export const DELETE_AGENT_FAILURE = "DELETE_AGENT_FAILURE";

export const GET_AGENT = "GET_AGENT";
export const GET_AGENT_SUCCESS = "GET_AGENT_SUCCESS";
export const GET_AGENT_FAILURE = "GET_AGENT_FAILURE";

// Agent interaction action types
export const INTERACT_WITH_AGENT = "INTERACT_WITH_AGENT";
export const INTERACT_WITH_AGENT_SUCCESS = "INTERACT_WITH_AGENT_SUCCESS";
export const INTERACT_WITH_AGENT_FAILURE = "INTERACT_WITH_AGENT_FAILURE";

// Agent Action Creators

// Create a new agent configuration
export const createAgent = (agentInput) => ({
  type: CREATE_AGENT,
  payload: agentInput,
});

export const createAgent22 = (agentInput) => {
  const actionObject = {
    type: CREATE_AGENT,
    payload: agentInput,
  };
  console.log(
    `PMM - SF - agentActions.js - createAgent - agentInput is: ${JSON.stringify(
      agentInput
    )}`
  );
  console.log(
    `PMM - SF - agentActions.js - createAgent - actionObject is: ${JSON.stringify(
      actionObject
    )}`
  );
  return actionObject;
};

// Successful agent creation
export const createAgentSuccess = (agent) => ({
  type: CREATE_AGENT_SUCCESS,
  payload: agent,
});

// Agent creation failure
export const createAgentFailure = (error) => ({
  type: CREATE_AGENT_FAILURE,
  error,
});

// Update an existing agent configuration
export const updateAgent = (agentInput) => ({
  type: UPDATE_AGENT,
  payload: agentInput,
});

// Successful agent update
export const updateAgentSuccess = (agent) => ({
  type: UPDATE_AGENT_SUCCESS,
  payload: agent,
});

// Agent update failure
export const updateAgentFailure = (error) => ({
  type: UPDATE_AGENT_FAILURE,
  error,
});

// Delete an agent configuration
export const deleteAgent = (deleteAgentInput) => ({
  type: DELETE_AGENT,
  payload: deleteAgentInput,
});

// Successful agent deletion
export const deleteAgentSuccess = (message) => ({
  type: DELETE_AGENT_SUCCESS,
  payload: message,
});

// Agent deletion failure
export const deleteAgentFailure = (error) => ({
  type: DELETE_AGENT_FAILURE,
  error,
});

// Retrieve an agent configuration
export const getAgent = (tenantId, agentId) => ({
  type: GET_AGENT,
  payload: { tenantId, agentId },
});

// Successful agent retrieval
export const getAgentSuccess = (agent) => ({
  type: GET_AGENT_SUCCESS,
  payload: agent,
});

// Agent retrieval failure
export const getAgentFailure = (error) => ({
  type: GET_AGENT_FAILURE,
  error,
});

// Agent interaction action creators
export const interactWithAgent = (tenantId, entityId, message) => ({
  type: INTERACT_WITH_AGENT,
  payload: { tenantId, agentId: entityId, message },
});

export const interactWithAgentSuccess = (response) => ({
  type: INTERACT_WITH_AGENT_SUCCESS,
  payload: response,
});

export const interactWithAgentFailure = (error) => ({
  type: INTERACT_WITH_AGENT_FAILURE,
  error,
});
